import { SelectBuyerList } from "components/form_components/BuyerListSelect";
import { BuyerSelectWithCustom } from "components/form_components/BuyerSelectWithCustom";
import { BuyerTypeSelect } from "components/form_components/BuyerTypeSelect";
import { CountryRegionSelect } from "components/form_components/CountryRegionSelect";
import { BidFilterContentProps, StyledFilterContent } from "./utils";

function BuyersFilterContent({ control, data }: BidFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Buyer filters">
      <BuyerSelectWithCustom
        buyersFieldName="buyers"
        customBuyersFieldName="customBuyers"
        label=""
        control={control}
        mode="multiple"
        placeholder="Search buyers..."
        disabled={(data?.buyerLists?.length ?? 0) > 0}
        allowClear
      />
      <SelectBuyerList
        name="buyerLists"
        label="Buyer lists"
        control={control}
        placeholder="Select..."
        mode="multiple"
        disabled={(data?.buyers?.length ?? 0) > 0}
        allowClear
      />
      <BuyerTypeSelect
        name="buyerCategories"
        control={control}
        multiple
        label="Buyer type"
        placeholder="Select..."
        allowClear
      />
      <CountryRegionSelect
        name="buyerCountryRegions"
        control={control}
        label="Buyer location"
        placeholder="Select..."
        allowClear
      />
    </StyledFilterContent>
  );
}

export default BuyersFilterContent;
